import React, { Dispatch, SetStateAction } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Button, Dialog } from '@material-ui/core';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

interface CustomizedDialogsProps {
  customDialogState: boolean;
  setCustomDialogState: Dispatch<SetStateAction<boolean>>;
  message: string;
}

const CustomizedDialogs: React.FC<CustomizedDialogsProps> = ({
  customDialogState,
  setCustomDialogState,
  message,
}: CustomizedDialogsProps) => {
  const handleToggle = () => {
    setCustomDialogState((state) => !state);
  };
  return (
    <div>
      <Dialog onClose={handleToggle} aria-labelledby="customized-dialog-title" open={customDialogState}>
        <DialogContent dividers>{message}</DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleToggle} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default CustomizedDialogs;
